import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function FloatingCTA() {
  return <motion.a href="sms:2158245130&body=Hi%20Blue%20Sky!%20I'm%20interested%20in%20getting%20a%20free%20estimate." target="_blank" rel="noopener noreferrer" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1.5,
    duration: 0.4,
    ease: [0.22, 1, 0.36, 1]
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-6 right-6 z-40 bg-gold text-navy w-14 h-14 rounded-full flex items-center justify-center shadow-[0_4px_20px_rgba(201,168,76,0.4)] hover:shadow-[0_6px_30px_rgba(201,168,76,0.6)] transition-shadow" aria-label="Contact us" data-id="element-153">
      <MessageCircle className="w-6 h-6" data-id="element-154" />

      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-gold/30 animate-ping" data-id="element-155" />
    </motion.a>;
}